import { useEffect, useCallback } from 'react'

import { Select, MenuItem, FormControl, Input } from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { getCookie } from 'helpers/cookies'
import { facilityActions } from 'store/facilities'
import { appActions } from 'store/app'
import usePermissions from 'helpers/usePermissions'
import _ from 'lodash'

const Component = () => {
  const dispatch = useDispatch()

  const fieldName = 'name'
  const idName = '_id'
  const extraOptions = { [fieldName]: 'Headquarter', [idName]: 'all' }

  const stateNameApp = 'app_data'
  const actionName = 'currentFacility'
  const doAction = (payload) => dispatch(appActions[actionName](payload))
  const doActionReset = () => dispatch(appActions[`${actionName}Reset`]())
  const currentFacility = useSelector((state) => state[stateNameApp][actionName])
  const facilityId = _.get(currentFacility, 'data.id', 'all')
  const itemHandler = (id) => {
    const payload = { id: id }
    doAction(payload)
  }

  const { userFacilities, isHQ, isProfileLoaded } = usePermissions()

  const stateNameFacilityList = 'facilities_data'
  const actionNameFacilityList = 'facilitiesList'

  const getFacilitiesList = useCallback(
    (payload) => {
      dispatch(facilityActions[actionNameFacilityList](payload))
    },
    [dispatch]
  )
  const resFacilitiesList = useSelector((state) => state[stateNameFacilityList][actionNameFacilityList])
  const status = resFacilitiesList?.status ?? ''
  const error = resFacilitiesList?.data?.error ?? 'Error'
  const facilitiesList = resFacilitiesList?.data?.items ?? []
  let options = facilitiesList.length > 0 ? _.map(facilitiesList, ({ _id, name }) => ({ _id, name })) : []

  if (isProfileLoaded && !isHQ && userFacilities.length > 0) {
    const assignedIds = userFacilities.map((f) => (typeof f === 'object' ? f._id : f))
    options = options.filter((f) => assignedIds.includes(f._id))
  }

  useEffect(() => {
    const accessToken = getCookie(`${process.env.REACT_APP_WEBSITE_NAME}accessToken`)
    if (!accessToken) return

    const payload = {
      data: { limit: 100, offset: 0, search: '' },
      token: accessToken
    }
    getFacilitiesList(payload)
  }, [getFacilitiesList])

  // Auto-select first facility for non-HQ users when no facility is selected
  useEffect(() => {
    if (isProfileLoaded && !isHQ && options.length > 0 && facilityId === 'all') {
      itemHandler(options[0]._id)
    }
  }, [isProfileLoaded, isHQ, options.length, facilityId]) // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = ['', 'initial', 'loading'].includes(status)

  if (['fail', 'error'].includes(status)) {
    console.log('Error loading options for the field: ', actionName, 'Details: ', error)
    options = [{ value: '', label: 'Error loading options' }]
  }

  const handleChange = (e) => {
    const facility = e.target.value
    if (facility === 'all') return doActionReset()
    itemHandler(facility)
  }

  return (
    <FormControl variant="standard" size="medium" sx={{ mx: 2 }}>
      <Select
        id="facility-selector"
        value={facilityId}
        disabled={isLoading}
        disableUnderline
        onChange={handleChange}
        sx={{
          '& .MuiInputBase-input': (theme) => {
            return { ...theme.typography.h6 }
          }
        }}
        input={<Input variant="standard" sx={{ padding: 20 }} />}
        style={{ height: 44, minWidth: 50 }}
      >
        {isHQ && (
          <MenuItem key={extraOptions._id} value={extraOptions._id} disabled={extraOptions.disabled}>
            {extraOptions.name}
          </MenuItem>
        )}
        {options.map((facility) => (
          <MenuItem key={facility._id} value={facility._id} disabled={facility.disabled}>
            {facility.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default Component
